import React from 'react'

import {
  Avatar,
  EntityTableCell,
  LogoImage,
  Tag,
  useMediaQueryContext,
} from '@fourthwall/components'
import type { TeamMemberItem } from '@modules/Dashboard/pages/Settings/pages/Team/Team.types'

import * as S from './TeamMember.styled'

export type TeamMemberProps = {
  teamMember: TeamMemberItem
}

const pendingLabel = 'Invitation sent'

export const TeamMember = ({ teamMember }: TeamMemberProps) => {
  const media = useMediaQueryContext()
  const pending = teamMember.invitationStatus === 'INVITED'

  if (teamMember.isPartner) {
    return (
      <EntityTableCell
        top={teamMember.name || ''}
        bottom={
          <S.BottomPartnerContent>
            <Tag label="partner" />
            {pending && pendingLabel}
          </S.BottomPartnerContent>
        }
        image={
          <LogoImage
            logo={teamMember.logoUri}
            placeholder={teamMember.name?.charAt(0)}
            size="extraSmall"
            aspectRatio={1}
          />
        }
      />
    )
  }

  const getBottom = () => {
    const label = pending ? pendingLabel : teamMember.email

    if (!media.tablet) {
      return (
        <S.BottomGroupContent>
          <S.BottomText>{label}</S.BottomText>
          <S.BottomText>{teamMember.roleName}</S.BottomText>
        </S.BottomGroupContent>
      )
    }

    return label
  }

  const displayedName = teamMember.isYou ? `${teamMember.name} (you)` : teamMember.name

  return (
    <EntityTableCell
      top={(pending ? teamMember.email : displayedName) || ''}
      bottom={getBottom()}
      image={<Avatar name={pending ? undefined : teamMember.name} />}
    />
  )
}
